angular.module('app.filters').filter('boxcastTvLink', () =>
    showUrl =>
    (showUrl || '').replace(
        'https://www.boxcast.com/show/#/',
        'https://boxcast.tv/channel/'
    )

);


// WEBPACK FOOTER //
// ./filters/boxcast_tv_link.js